import CreateMixin from './Create.js';
import http from '@/components/services/http-common';
import EventBus from '@/components/services/EventBus.js';
import moment from 'moment/moment';

export default {
    name: 'CreateV2',
    mixins: [CreateMixin],
    watch: {
        dialog: {
            handler(value) {
                if (value && this.isEdit) {
                    this.fetchSalaryHistory();
                }
            }
        }
    },
    data() {
        return {
            activeTab: 0,
            workLogTab: 1, // 0 for Trạng thái làm việc, 1 for Vị trí/Ca/Cột
            editAddress: false,
            editIdInfo: false,
            editBasicInfo: false,
            editEducation: false,
            editFamily: false,
            editOtherInfo: false,
            editSkills: false,
            awardDialog: false,
            awardForm: { title: '', year: null },
            awardEditIndex: -1,
            editBank: false,
            editSalarySetting: false,
            salarySettingDialog: false,
            salaryHistory: [],
            currentSalaryConfig: {
                id: null,
                contractSalary: null,
                insuranceSalary: null,
                workAllowance: null,
                saleAllowance: null,
                trainAllowance: null,
                specAllowance: null,
                kpiSalary: null,
                phoneFee: null,
                businessFee: null,
                lunchFee: null,
                note: '',
                taskAllowance: null,
                supportAllowance: null
            },
            salarySettingForm: {
                id: 0,
                employeeCode: '',
                from: '',
                to: '2100-01-01',
                contractSalary: 0,
                insuranceSalary: 0,
                workAllowance: 0,
                saleAllowance: 0,
                trainAllowance: 0,
                specAllowance: 0,
                kpiSalary: 0,
                phoneFee: 0,
                businessFee: 0,
                lunchFee: 0,
                note: '',
                taskAllowance: 0,
                supportAllowance: 0
            },

            isSalaryUnlocked: false,
            unlockPasswordDialog: false,
            unlockPassword: '',
            salaryHistoryPayouts: [],
            salaryHistoryPayoutHeaders: [
                { text: 'Mã NS', value: 'employeeCode' },
                { text: 'Tên NS', value: 'employeeName' },
                { text: 'Tháng 1', value: 'm1', align: 'right' },
                { text: 'Tháng 2', value: 'm2', align: 'right' },
                { text: 'Tháng 3', value: 'm3', align: 'right' },
                { text: 'Tháng 4', value: 'm4', align: 'right' },
                { text: 'Tháng 5', value: 'm5', align: 'right' },
                { text: 'Tháng 6', value: 'm6', align: 'right' },
                { text: 'Tháng 7', value: 'm7', align: 'right' },
                { text: 'Tháng 8', value: 'm8', align: 'right' },
                { text: 'Tháng 9', value: 'm9', align: 'right' },
                { text: 'Tháng 10', value: 'm10', align: 'right' },
                { text: 'Tháng 11', value: 'm11', align: 'right' },
                { text: 'Tháng 12', value: 'm12', align: 'right' },
            ],
        }
    },
    methods: {
        openAwardDialog() {
            this.awardEditIndex = -1;
            this.awardForm = { title: '', year: null };
            this.awardDialog = true;
        },
        editAward(award) {
            this.awardEditIndex = this.form.employeeAwards.indexOf(award);
            this.awardForm = Object.assign({}, award);
            this.awardDialog = true;
        },
        deleteAward(award) {
            if (confirm('Bạn có chắc chắn muốn xóa giải thưởng này?')) {
                let index = this.form.employeeAwards.indexOf(award);
                if (index > -1) {
                    this.form.employeeAwards.splice(index, 1);
                }
            }
        },
        saveAward() {
            if (!this.form.employeeAwards) this.$set(this.form, 'employeeAwards', []);
            if (this.awardEditIndex > -1) {
                this.$set(this.form.employeeAwards, this.awardEditIndex, Object.assign({}, this.awardForm));
            } else {
                this.form.employeeAwards.push(Object.assign({}, this.awardForm));
            }
            this.closeAwardDialog();
        },
        closeAwardDialog() {
            this.awardDialog = false;
        },

        saveSkills() {
            let payload = {
                LanguageEmployees: (this.form.languages || []).map(lang => ({
                    LanguageCode: lang.languageCode || (lang.language && lang.language.code ? lang.language.code : ''),
                    LanguageLevelCode: lang.languageLevelCode || (lang.languageLevel && lang.languageLevel.code ? lang.languageLevel.code : '')
                })),
                EmployeeCertificates: (this.form.employeeCertificates || []).map(cert => ({
                    Title: cert.title || '',
                    Type: cert.type || ''
                })),
                EmployeeAwards: (this.form.employeeAwards || []).map(award => ({
                    Year: award.year ? parseInt(award.year) : 0,
                    Title: award.title || ''
                })),
                PharmaCert: this.form.pharmaCert || ''
            };

            return http.put(`employees/${this.item.code}/skill`, payload).then(res => {
                this.editSkills = false;
                // let notif = {
                //     message: "Cập nhật kỹ năng chuyên môn thành công",
                //     icon: 'success',
                //     toast: false,
                // }
                // EventBus.$emit('hasError', notif);
                this.fetch();
            }).catch(err => {
                let notif = {
                    message: "Cập nhật kỹ năng chuyên môn thất bại",
                    icon: 'error',
                    toast: false,
                }
                EventBus.$emit('hasError', notif);
            });
        },

        saveBank() {
            let payload = {
                BankCode: this.form.bankCode || '',
                BankNumber: this.form.bankNumber || '',
                Bank2Code: this.form.bank2Code || '',
                Bank2Number: this.form.bank2Number || ''
            };

            return http.put(`employees/${this.item.code}/bank`, payload).then(res => {
                this.editBank = false;
                // let notif = {
                //     message: "Cập nhật tài khoản ngân hàng thành công",
                //     icon: 'success',
                //     toast: false,
                // }
                // EventBus.$emit('hasError', notif);
                this.fetch();
            }).catch(err => {
                let notif = {
                    message: "Cập nhật tài khoản ngân hàng thất bại",
                    icon: 'error',
                    toast: false,
                }
                EventBus.$emit('hasError', notif);
            });
        },

        saveBasicInfo() {
            let payload = {
                Avatar: this.form.avatar || '',
                Name: this.form.name || '',
                Gender: this.form.gender || false,
                Mail: this.form.mail || '',
                PhoneNumber: this.form.phoneNumber || '',
                BirthDay: this.form.birthDay || null,
                HireDate: this.form.hireDate || null,
                EmployeeReturn: this.form.employeeReturn || 0
            };
            return http.put(`employees/${this.item.code}/basic`, payload).then(res => {
                this.editBasicInfo = false;
                // let notif = {
                //     message: "Cập nhật thông tin cơ bản thành công",
                //     icon: 'success',
                //     toast: false,
                // }
                // EventBus.$emit('hasError', notif);
                this.$emit('fetch');
            }).catch(err => {
                let notif = {
                    message: "Cập nhật thông tin thất bại",
                    icon: 'error',
                    toast: false,
                }
                EventBus.$emit('hasError', notif);
            });
        },
        saveAddress() {
            let payload = {
                newCityId: this.form.newCityId || 0,
                newWardId: this.form.newWardId || 0,
                address: this.form.address || '',
                newCityId2: this.form.newCityId2 || 0,
                newWardId2: this.form.newWardId2 || 0,
                domicileAddress: this.form.domicileAddress || ''
            };
            return http.put(`employees/${this.item.code}/address`, payload).then(res => {
                this.editAddress = false;
                // let notif = {
                //     message: "Cập nhật địa chỉ thành công",
                //     icon: 'success',
                //     toast: false,
                // }
                // EventBus.$emit('hasError', notif);
                this.$emit('fetch');
            }).catch(err => {
                let notif = {
                    message: "Cập nhật địa chỉ thất bại",
                    icon: 'error',
                    toast: false,
                }
                EventBus.$emit('hasError', notif);
            });
        },
        saveIdInfo() {
            let payload = {
                idNumber: this.form.idNumber || '',
                idDate: this.form.idDate || null,
                idPlace: this.form.idPlace || ''
            };
            return http.put(`employees/${this.item.code}/idInfo`, payload).then(res => {
                this.editIdInfo = false;
                this.$emit('fetch');
            }).catch(err => {
                let notif = {
                    message: "Cập nhật CCCD thất bại",
                    icon: 'error',
                    toast: false,
                }
                EventBus.$emit('hasError', notif);
            });
        },
        saveEducation() {
            let payload = {
                EducationLevelCode: this.form.educationLevelCode || '',
                UniversityCode: this.form.universityCode || '',
                EducationMajorCode: this.form.educationMajorCode || '',
                EduRating1: this.form.eduRating1 || '',
                EduDateFrom1: this.form.eduDateFrom1 || null,
                EduDateTo1: this.form.eduDateTo1 || null,

                EducationLevel2Code: this.form.educationLevel2Code || '',
                University2Code: this.form.university2Code || '',
                EducationMajor2Code: this.form.educationMajor2Code || '',
                EduRating2: this.form.eduRating2 || '',
                EduDateFrom2: this.form.eduDateFrom2 || null,
                EduDateTo2: this.form.eduDateTo2 || null
            };
            return http.put(`employees/${this.item.code}/education`, payload).then(res => {
                this.editEducation = false;
                this.$emit('fetch');
            }).catch(err => {
                let notif = {
                    message: "Cập nhật học vấn thất bại",
                    icon: 'error',
                    toast: false,
                }
                EventBus.$emit('hasError', notif);
            });
        },
        addFamilyItem() {
            if (!this.families) this.families = [];
            this.families.push({
                relationType: '',
                memberName: '',
                memberEmployeeCode: ''
            });
        },
        removeFamilyItem(index) {
            this.families.splice(index, 1);
        },
        saveFamily() {
            let payload = {
                EmergencyNumber: this.form.emergencyNumber || '',
                Families: this.families.map(f => ({
                    RelationType: f.relationType || '',
                    MemberName: f.memberName || '',
                    MemberEmployeeCode: f.memberEmployeeCode || ''
                }))
            };

            return http.put(`employees/${this.item.code}/family`, payload).then(res => {
                this.editFamily = false;
                this.$emit('fetch');
            }).catch(err => {
                let notif = {
                    message: "Cập nhật thông tin gia đình thất bại",
                    icon: 'error',
                    toast: false,
                }
                EventBus.$emit('hasError', notif);
            });
        },
        saveOtherInfo() {
            let payload = {
                OriginCode: this.form.originCode || '',
                EthnicityCode: this.form.ethnicityCode || '',
                ReligionCode: this.form.religionCode || '',
                Marriage: this.form.marriage || ''
            };
            return http.put(`employees/${this.item.code}/extra-info`, payload).then(res => {
                this.editOtherInfo = false;
                this.$emit('fetch');
            }).catch(err => {
                let notif = {
                    message: "Cập nhật thông tin khác thất bại",
                    icon: 'error',
                    toast: false,
                }
                EventBus.$emit('hasError', notif);
            });
        },
        saveSalarySetting() {
            if (!this.currentSalaryConfig.id) {
                this.editSalarySetting = false;
                return;
            }
            let payload = Object.assign({}, this.currentSalaryConfig);
            return http.put(`employeeSalarySetups/details/${payload.id}`, payload).then(res => {
                this.editSalarySetting = false;
                this.fetchSalaryHistory();
            }).catch(err => {
                let notif = { message: "Cập nhật thất bại", icon: 'error', toast: false };
                EventBus.$emit('hasError', notif);
            });
        },
        deleteSalarySettingHistory(item) {
            if (confirm('Bạn có chắc chắn muốn xóa cài đặt lương này?')) {
                return http.delete(`employeeSalarySetups/details/${item.id}`).then(res => {
                    this.fetchSalaryHistory();
                }).catch(err => {
                    let notif = { message: "Xóa thất bại", icon: 'error', toast: false };
                    EventBus.$emit('hasError', notif);
                });
            }
        },
        openSalarySettingDialog() {
            this.salarySettingForm = {
                id: 0,
                employeeCode: this.item ? this.item.code : '',
                from: '',
                to: '2100-01-01',
                contractSalary: 0,
                insuranceSalary: 0,
                workAllowance: 0,
                saleAllowance: 0,
                trainAllowance: 0,
                specAllowance: 0,
                kpiSalary: 0,
                phoneFee: 0,
                businessFee: 0,
                lunchFee: 0
            };
            this.salarySettingDialog = true;
        },
        editSalarySettingHistory(item) {
            this.salarySettingForm = Object.assign({}, item);
            if (this.salarySettingForm.from) {
                this.salarySettingForm.from = moment(this.salarySettingForm.from).format('YYYY-MM-DD');
            }
            if (this.salarySettingForm.to) {
                this.salarySettingForm.to = moment(this.salarySettingForm.to).format('YYYY-MM-DD');
            }
            this.salarySettingDialog = true;
        },
        saveSalarySettingHistory() {
            let payload = Object.assign({}, this.salarySettingForm);
            if (!payload.employeeCode && this.item) {
                payload.employeeCode = this.item.code;
            }

            if (payload.id) {
                return http.put(`employeeSalarySetups/details/${payload.id}`, payload).then(res => {
                    this.salarySettingDialog = false;
                    this.fetchSalaryHistory();
                }).catch(err => {
                    let notif = {
                        message: "Cập nhật cài đặt lương thất bại",
                        icon: 'error',
                        toast: false,
                    };
                    EventBus.$emit('hasError', notif);
                });
            } else {
                return http.post("employeeSalarySetups/details", payload).then(res => {
                    this.salarySettingDialog = false;
                    this.fetchSalaryHistory();
                }).catch(err => {
                    let notif = {
                        message: "Thêm cài đặt lương thất bại",
                        icon: 'error',
                        toast: false,
                    };
                    EventBus.$emit('hasError', notif);
                });
            }
        },
        formatCurrency(value) {
            if (!value) return '';
            return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(value);
        },
        submitUnlockPassword() {
            if (!this.unlockPassword) {
                EventBus.$emit('hasError', {
                    message: "Vui lòng nhập mật khẩu!",
                    icon: 'error',
                    toast: false,
                });
                return;
            }

            http.post('cabAuthentication/login/v2', { password: this.unlockPassword })
                .then(res => {
                    this.isSalaryUnlocked = true;
                    this.unlockPasswordDialog = false;
                    this.unlockPassword = '';
                })
                .catch(err => {
                    EventBus.$emit('hasError', {
                        message: "Mật khẩu không chính xác!",
                        icon: 'error',
                        toast: false,
                    });
                });
        },
        fetchSalaryHistory() {
            if (!this.item || !this.item.code) return;

            // Mock data for salary payout table
            this.salaryHistoryPayouts = [
                {
                    employeeCode: this.item.code,
                    employeeName: this.item.name,
                    m1: 15000000, m2: 15000000, m3: 15500000, m4: 15500000,
                    m5: 16000000, m6: 16000000, m7: null, m8: null, m9: null, m10: null, m11: null, m12: null
                }
            ];

            return http.get(`employeeSalarySetups/details/${this.item.code}`).then(res => {
                let history = res.data.data || res.data;
                this.salaryHistory = history;

                const today = moment().format('YYYY-MM-DD');
                const currentConfig = history.find(item => {
                    const fromDate = item.from ? moment(item.from).format('YYYY-MM-DD') : '1900-01-01';
                    const toDate = item.to && item.to !== '0001-01-01T00:00:00' ? moment(item.to).format('YYYY-MM-DD') : '2100-01-01';
                    return fromDate <= today && today <= toDate;
                });

                if (currentConfig) {
                    this.currentSalaryConfig = Object.assign({}, currentConfig);
                } else {
                    this.currentSalaryConfig = {
                        id: null,
                        contractSalary: null,
                        insuranceSalary: null,
                        workAllowance: null,
                        saleAllowance: null,
                        trainAllowance: null,
                        specAllowance: null,
                        kpiSalary: null,
                        phoneFee: null,
                        businessFee: null,
                        lunchFee: null
                    };
                }
            }).catch(err => {
                console.error("Lỗi khi tải lịch sử lương", err);
            });
        }
    }
}
